// De tekeningen zelf, los van React.
//
// Ze staan apart omdat niet alles wat een icoon nodig heeft een React-onderdeel is: het
// vouwknopje in de kop wordt door ProseMirror getekend, met gewoon DOM. En omdat Node wel
// TypeScript leest maar geen JSX, kan een test alleen bij bestanden zonder .tsx in de keten.

export type IcoonNaam =
  | "zoek" | "inbox" | "kalender" | "ster" | "taken" | "map" | "archief" | "prullenbak"
  | "plus" | "lijstje" | "foto" | "klok" | "meer" | "pin" | "terug" | "menu"
  | "download" | "kruis" | "vink" | "notitie" | "wolk" | "link" | "tag" | "kaarten" | "sleutel"
  | "ververs" | "paperclip" | "tabel" | "uitroep" | "omlaag" | "greep" | "kopie";

/** Ook los te gebruiken: de sleepgreep en het vouwknopje tekenen hun icoon zonder React. */
export const ICOONPADEN: Record<IcoonNaam, string> = {
  zoek: "M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14M20 20l-3.5-3.5",
  inbox: "M3 12h4l2 3h6l2-3h4M5 5h14l2 7v7H3v-7z",
  kalender: "M5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2M3 10h18M8 3v4M16 3v4",
  ster: "M12 3.5l2.6 5.5 6 .8-4.4 4.2 1.1 6-5.3-2.9-5.3 2.9 1.1-6L3.4 9.8l6-.8z",
  taken: "M5 4h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2M8 12l2.5 2.5L16 9",
  map: "M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
  archief: "M4 4h16v4H4zM5 8v11h14V8M10 12h4",
  prullenbak: "M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13",
  plus: "M12 5v14M5 12h14",
  lijstje: "M4 6l2 2 3-3M4 14l2 2 3-3M13 7h7M13 15h7",
  foto: "M5 5h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2M21 16l-5-5-6 6M8.5 10.5h.01",
  klok: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M12 7v5l3 2",
  meer: "M5 12h.01M12 12h.01M19 12h.01",
  pin: "M9 3h6l-1 6 3 3v2H7v-2l3-3zM12 14v7",
  terug: "M15 5l-7 7 7 7",
  menu: "M4 7h16M4 12h16M4 17h16",
  download: "M12 4v11M8 11l4 4 4-4M5 19h14",
  kruis: "M6 6l12 12M18 6L6 18",
  vink: "M5 13l4 4L19 7",
  notitie: "M7 3h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2M9 8h6M9 12h6M9 16h4",
  wolk: "M5 18a4 4 0 0 1 .8-7.9A6 6 0 0 1 17 9.5a3.5 3.5 0 0 1 1 6.9",
  link: "M10 13a5 5 0 0 0 7 0l2-2a5 5 0 0 0-7-7l-1 1M14 11a5 5 0 0 0-7 0l-2 2a5 5 0 0 0 7 7l1-1",
  tag: "M3 12V5a2 2 0 0 1 2-2h7l9 9-9 9zM7.5 7.5h.01",
  kaarten: "M4 4h6v7H4zM14 4h6v4h-6zM4 15h6v5H4zM14 12h6v8h-6z",
  sleutel: "M14 7a4 4 0 1 1-3.5 5.9L4 19v2H2v-3l7.1-7.1A4 4 0 0 1 14 7zM15.5 9.5h.01",
  ververs: "M20 12a8 8 0 1 1-2.34-5.66M20 3v4h-4",
  paperclip: "M17 8.5v8a5 5 0 0 1-10 0V7a3.5 3.5 0 0 1 7 0v9a2 2 0 0 1-4 0V8.5",
  tabel: "M4 5h16v14H4zM4 10h16M4 15h16M10 5v14",
  uitroep: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M12 7v6M12 16.5h.01",
  omlaag: "M6 9l6 6 6-6",
  // Zes puntjes, zoals overal waar je iets kunt verslepen.
  greep: "M9 5h.01M15 5h.01M9 12h.01M15 12h.01M9 19h.01M15 19h.01",
  kopie: "M9 9h10v10a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2M5 15V5a2 2 0 0 1 2-2h8"
};
